import {PeriodTimeForms, PeriodMapping, Period} from "../types";

const periodMappings: PeriodMapping = {
  yearly: {
    adjective: "annual",
    adverb: "yearly",
  },
  quarterly: {
    adjective: "quarterly",
    adverb: "quarterly",
  },
  semestral: {
    adjective: "semestral",
    adverb: "semiannually",
  },
};

export const getDateWithDaysOffset = (date: Date, days: number): Date => {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days);

  return newDate;
};

export const getMonthDayYearDateString = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const getFormattedDueDate = (date: Date, days: number) => {
  return getMonthDayYearDateString(getDateWithDaysOffset(date, days))
}

export const getPeriodString = (
  period: Period
): PeriodTimeForms | undefined => {
  return periodMappings?.[period] || undefined;
};
